// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../../services/apiService/apiService';

export const depositSlipActions = {
  GET_DEPOSIT_SLIP_DETAILS: 'GET_DEPOSIT_SLIP_DETAILS',
  GET_UPDATED_DEPOSIT_SLIP_DETAILS: 'GET_UPDATED_DEPOSIT_SLIP_DETAILS',
  GET_FILTERED_DATA_DEPOSIT_SLIP: 'GET_FILTERED_DATA_DEPOSIT_SLIP'
};

export const getDepositSlipDetailsAction = (obj: Object) => ({
  type: depositSlipActions.GET_DEPOSIT_SLIP_DETAILS,
  payload: obj
});

export const getUpdatedDepositSlipDetailsAction = (obj: Object) => ({
  type: depositSlipActions.GET_UPDATED_DEPOSIT_SLIP_DETAILS,
  payload: obj
});

export const getFilteredData = (filteredArray: Array) => (
  dispatch: Function,
  getState
) => {
  const { data, originalData } = getState().depositSlipState;
  if (
    !originalData ||
    !originalData.depositSlipRowDTOList ||
    originalData.depositSlipRowDTOList.length <= 0
  ) {
    return;
  }

  const depositSlipRowDTOListClone = [...originalData.depositSlipRowDTOList];
  let filteredData = [];
  if (!filteredArray || !filteredArray.length) {
    filteredData = depositSlipRowDTOListClone;
  } else {
    filteredData = (depositSlipRowDTOListClone || []).filter(row => {
      if (row && filteredArray.indexOf(row.cnote) > -1) {
        return row;
      }
    });
  }

  dispatch({
    type: depositSlipActions.GET_FILTERED_DATA_DEPOSIT_SLIP,
    payload: filteredData
  });
};

export const getDepositSlipDetails = (method: string, slipType: string) => (
  dispatch: Function
) => {
  dispatch(
    getDepositSlipDetailsAction({
      fetching: true,
      fetched: false,
      data: null,
      originalData: null,
      slipGenerationSuccessful: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getDepositSlipDetailsForCreations',
    params: { paymentType: method, depositSlipType: slipType },
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDepositSlipDetailsAction({
            fetching: false,
            fetched: true,
            data: res.payload,
            originalData: Object.assign({}, res.payload)
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getDepositSlipDetailsAction({
            fetched: true,
            fetching: false,
            data: null,
            originalData: null
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getDepositSlipDetailsAction({
          fetched: true,
          fetching: false,
          data: null,
          originalData: null
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
      //  eslint-disable-next-line no-console
      console.log('Failed ', res, this.state);
    },
    catchCb: res => {
      dispatch(
        getDepositSlipDetailsAction({
          fetched: true,
          fetching: false,
          data: null,
          originalData: null
        })
      );
      toastr.error('Exception', 'Exception in fetching deposit Slip details', {
        timeout: 3000
      });
      //  eslint-disable-next-line no-console
      console.log('Caught ', res);
    }
  };
  return makeApiCall(requestObj);
};

function removeNonSelectedRowFilter(slipDetails) {
  const { depositSlipRowDTOList } = slipDetails;
  let filteredDto;
  if (depositSlipRowDTOList) {
    filteredDto = depositSlipRowDTOList.filter(row => row.isSelected);
  } else {
    filteredDto = depositSlipRowDTOList;
  }
  slipDetails.depositSlipRowDTOList = filteredDto;
  return slipDetails;
}

export const getUpdatedDepositSlipDetails = (
  slipDetails: Object,
  slipType: string,
  file
) => (dispatch: Function) => {
  dispatch(
    getUpdatedDepositSlipDetailsAction({
      fetching: true,
      fetched: false,
      printSlipDetails: null,
      slipGenerationSuccessful: false
    })
  );
  const filteredSlipDetails = removeNonSelectedRowFilter(slipDetails);

  const formData = new FormData();
  formData.append(
    'dto',
    new Blob([JSON.stringify(filteredSlipDetails)], {
      type: 'application/json'
    })
  );
  if (slipType === 'MANUAL' && file) {
    formData.append('file', file[0]);
  }

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'printDepositSlipDetails',
    method: 'POST',
    postFormData: true,
    data: formData,
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getUpdatedDepositSlipDetailsAction({
            fetching: false,
            fetched: true,
            printSlipDetails: res.payload,
            slipGenerationSuccessful: true
          })
        );
      } else if (res.status === 'FAILURE') {
        dispatch(
          getUpdatedDepositSlipDetailsAction({
            fetched: true,
            fetching: false,
            printSlipDetails: null
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getUpdatedDepositSlipDetailsAction({
          fetched: true,
          fetching: false,
          printSlipDetails: null
        })
      );
      toastr.error('Failure', res.errorMessage, { timeout: 3000 });
      //  eslint-disable-next-line no-console
      console.log('Failed ', res);
    },
    catchCb: res => {
      dispatch(
        getUpdatedDepositSlipDetailsAction({
          fetched: true,
          fetching: false,
          printSlipDetails: null
        })
      );
      toastr.error('Exception', 'Exception in fetching deposit Slip details', {
        timeout: 3000
      });
      //  eslint-disable-next-line no-console
      console.log('Caught ', res);
    }
  };
  return makeApiCall(requestObj);
};
